import { useEffect, useRef, useState } from 'react'

interface Props {
  id: string
}

export function useSkillHandler({ id }: Props) {
  const $skillRef = useRef<HTMLIFrameElement>(null)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    const f = ({ data }: MessageEvent) => {
      if (data.__krkr__ && data._id === id && data.type === 'resize') {
        setHeight(data.height)
      }
    }
    window.addEventListener('message', f)
    return () => {
      window.removeEventListener('message', f)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    $skillRef,
    height,
  }
}
